import React from "react";
import CreateSession from "./CreateSession";

const LoginRedirect = () => <CreateSession />;

export default LoginRedirect;
